import { styled } from "simplydo/react/styled";

const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    display: flex;
    gap: 8px;
    line-height: 1.4;
  }

  .code {
    flex: none;
    font-variant-numeric: tabular-nums;
    color: #5b6470;
  }
`;

type SicCodeListProps = {
  codes: string[];
  descriptions?: Record<string, string>;
};

/** SIC codes with what each one means. */
export const SicCodeList = ({ codes, descriptions }: SicCodeListProps) => (
  <List>
    {codes.map((code) => (
      <li key={code}>
        <span className="code">{code}</span>
        {descriptions?.[code] ?? "Unknown code"}
      </li>
    ))}
  </List>
);
